import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
  BreakPointDesktop,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background:
      "linear-gradient(180deg, rgba(16, 16, 16, 0.98) 0%, rgba(9, 9, 9, 0.98) 100%)",
    gap: theme.spacing.space8,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing.space24,
    boxSizing: "border-box",
    border: "1px solid rgba(52, 59, 79, 0.30)",
    borderRadius: theme.radius.large,
    width: "-webkit-fill-available",
    [BreakPointDesktop]: {
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  detail: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row !important",
    marginTop: theme.spacing.space16,
    "& div": {
      flex: 1,
    },
    [BreakPointTablet]: {
      marginTop: theme.spacing.space8,
    },
    [BreakPointMobile]: {
      marginTop: theme.spacing.space8,
    },
  },
  statInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
  },
  label: {
    margin: `${theme.spacing.space4}px 0px`,
  },
  iconStat: {
    height: 51,
    width: 51,
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
    // webOS 22 (Chromium <=87): outline ignores border-radius; box-shadow follows it
    "@supports not (aspect-ratio: 1 / 1)": {
      outline: "none",
      boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.80)",
    },
  },
  rootMobile: {
    display: "flex",
    gap: theme.spacing.space8,
    margin: `0px ${theme.spacing.space16}px`,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    borderRadius: theme.radius.medium,
    backgroundColor: theme.colors.Background1,
    padding: theme.spacing.space12,
    minWidth: 0,
    [BreakPointMobile]: {
      flex: 1,
    },
  },
  icon: {
    background:
      "linear-gradient(152deg, rgba(255, 255, 255, 0.15) 8.3%, rgba(255, 255, 255, 0.50) 92.13%);",
    borderRadius: "50%",
    height: 40,
    width: 40,
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    height: 24,
    flexShrink: 0,
    width: 24,
    objectFit: "contain",
  },
  mobileLabel: {
    whiteSpace: "nowrap",
    "@media (max-width: 360px)": {
      whiteSpace: "normal",
    },
  },
}));
